import { Routes, Route } from "react-router-dom";
import Shell from "./layout/Shell";
import Home from "./pages/Home";
import SurahListPage from "./pages/Surah/List";
import SurahViewPage from "./pages/Surah/View";
import MafatihPage from "./pages/Mafatih/MafatihPage";
import DuaReadListPage from "./pages/Mafatih/DuaReadListPage";
import DuaDetailPage from "./pages/Mafatih/DuaDetailPage";
import ListenIndexPage from "./pages/Listen/Index";
import ByReciterPage from "./pages/Listen/ByReciter";
import PlayerPage from "./pages/Listen/Player";
import DuaListPage from "./pages/Duas/Index";
import DuaPlayerPage from "./pages/Duas/Player";
import PrayerTimes from "./pages/PrayerTimes";
import Settings from "./pages/Settings";
import About from "./pages/About";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/surah" element={<SurahListPage />} />
        <Route path="/surah/:id" element={<SurahViewPage />} />
        <Route path="/mafatih" element={<MafatihPage />} />
        <Route path="/mafatih/list/:parentSlug" element={<DuaReadListPage />} />
        <Route path="/mafatih/list/:parentSlug/:duaSlug" element={<DuaDetailPage />} />
        <Route path="/listen" element={<ListenIndexPage />} />
        <Route path="/listen/:reciterId" element={<ByReciterPage />} />
        <Route path="/listen/:reciterId/:surahNumber" element={<PlayerPage />} />
         <Route path="/duas" element={<DuaListPage />} />
        <Route path="/duas/:duaId" element={<DuaPlayerPage />} />
        <Route path="/prayer-times" element={<PrayerTimes />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Shell>
  );
}
